let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1D7d8")).then(() => parcelRequire('6V7VR'));